import moment from 'moment'

/**
 * Filter to use in Smart Table instead of standard filter
 * The stSetFilter replaces the filter used when searching through Smart Table.
 * When the default behavior for stSearch does not meet your demands, like in a
 * select where one entry is a substring of another, use a custom filter to achieve your goals.
 *
 * @class stLocalFilterTable
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc filter
 * @name mwApp/common.filter:stLocalFilterTable
 */
/* @ngInject */
export function stLocalFilterTable ($filter) {
  /**
   * Get all fields chains from object
   *
   * {
   *   firstname: {
   *     email: '2',
   *     lastname: '1'
   *   },
   *   lastname: {
   *     firstname: {
   *       email: '3'
   *     }
   *   }
   * }
   * ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
   * {
   *   'firstname,lastname': '1',
   *   'firstname,email': '2',
   *   'lastname,firstname,email': '3'
   * }
   */
  function getChains (o) {
    var chains = Object.create(null);
    (function iterate (o, path) {
      for (var k in o) {
        if (o.hasOwnProperty(k)) {
          var npath = (path ? path + ',' : '') + k
          if (typeof o[k] === 'object') {
            iterate(o[k], npath)
          } else {
            chains[npath] = o[k]
          }
        }
      }
    })(o)
    return chains
  }

  /**
   * Find Null values recursively in object
   *
   * @param  {Object} o
   * @return {Boolean} - object has null values or no
   */
  function containsNull (o) {
    if (o === null) {
      return true
    }

    if (Array.isArray(o)) {
      for (var i = o.length; i--;) {
        if (o[i] === null) {
          return true
        }
      }
    }

    if (typeof o === 'object') {
      for (var k in o) {
        if (o.hasOwnProperty(k) && containsNull(o[k])) {
          return true
        }
      }
    }

    return false
  }

  var filterFilter = $filter('filter')
  var filterFilterBy = $filter('filterBy')

  function standardComparator (obj, text) {
    text = String(text).toLowerCase()
    return String(obj).toLowerCase().indexOf(text) > -1
  }

  // http://embed.plnkr.co/Idbc1JNHKylHuX6mNwZ6
  function customComparator (actual, expected) {
    if (actual === null) {
      return containsNull(expected)
    }

    // hack, we need to pass filter object like string,
    // because in the other case $filter service will travel through actual object
    // e.g. filter like {higher:10} will get 'higher' property from each number, and compare it against 10
    // but we need special logic for object filters, for dates and numbers
    if (expected && expected[0] === '{') {
      expected = JSON.parse(expected)
    }

    var isHigher = typeof expected.higher === 'number'
    var isLower = typeof expected.lower === 'number'

    if (typeof expected === 'object') {
      // in array
      if (Array.isArray(expected) && expected.length) {
        return expected.indexOf(actual) !== -1
      }

      // date range
      if (expected.before || expected.after) {
        try {
          var itemDate = moment(actual)
          return !((expected.before && itemDate.isAfter(expected.before)) ||
                   (expected.after && itemDate.isBefore(expected.after)))
        } catch (e) {
          return false
        }
      } else

      // number range
      if (isHigher || isLower) {
        var itemValue = +actual
        return !((isLower && itemValue > expected.lower) ||
                    (isHigher && itemValue < expected.higher))
      }

      return true
    }
    return standardComparator(actual, expected)
  }

  // stLocalFilterTable filter
  return function (input, predicate) {
    var result = input.slice()
    var or = null

    // we use 'or' workaround to be able to filter by several fields with OR condition
    if (predicate.or && typeof predicate.or === 'object') {
      var ors = getChains(predicate.or)
      for (var k in ors) { // eslint-disable-line guard-for-in
        result = filterFilterBy(result, k, ors[k])
      }
      or = predicate.or
      delete predicate.or
    }
    // filter by AND condition
    result = filterFilter(result, predicate, customComparator)

    // restore OR conditions for classes,
    // to be able to use like ... st-search-class-by="or.firstname.lastname"
    if (or) {
      angular.extend(predicate, { or })
    }

    //TODO: add backend filtration
    if (predicate && predicate.subscriptionType && predicate.subscriptionType.includes('Subscription')) {
      result = result.filter(sub => !sub.ecommerceEnabled)
    }
    if (predicate && predicate.subscriptionType && predicate.subscriptionType.includes('Subscription ECWID')) {
      result = result.concat(input.filter(sub => sub.ecommerceEnabled))
    }
    return result
  }
}
